export default {
  region: (state) => state.region,
  regions: (state) => state.regions
}



// WEBPACK FOOTER //
// ./src/components/region/store/getters.js